import styled from 'styled-components';
import { device, spacing } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  gap: 48px;
  padding: 40px ${spacing.detailsSidePadding} 40px ${spacing.detailsSidePadding};

  @media (max-width: ${device.desktop}px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  .anchor-style {
    &:visited,
    &:link {
      color: ${({ theme }) => theme.primary_300};
    }

    &:hover {
      opacity: 0.7;
    }
  }

  @media (max-width: ${device.mobile}px) {
    padding-left: 32px;
    padding-right: 16px;
  }
`;

export const VideoContainer = styled.figure`
  display: flex;
  flex: 1;
  max-width: 1280px;
  min-width: 280px;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16 / 9;

  iframe {
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.small {
    gap: 4px;
  }
`;
